import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnDestroy,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Item, Organization } from '../../shared/sdk';
import { ItemService } from '../../items/item.service';
import { OrganizationService } from '../../organizations/organization.service';
import { take, switchMap, takeUntil, map, startWith } from 'rxjs/operators';
import { Subject, Observable } from 'rxjs';

@Component({
  selector: 'app-document-item-save-btn',
  templateUrl: './document-item-save-btn.component.html',
  styleUrls: ['./document-item-save-btn.component.css'],
})
export class DocumentItemSaveBtnComponent implements OnInit, OnDestroy {
  @Input() item: FormGroup;
  @Output() saved: EventEmitter<Item> = new EventEmitter();
  loading: any = {};
  disabled$: Observable<boolean>;
  private onDestroy$: Subject<void> = new Subject();

  constructor(
    private itemService: ItemService,
    private orgService: OrganizationService,
  ) {}

  ngOnInit(): void {
    this.disabled$ = this.item.valueChanges.pipe(
      startWith(null),
      map(() => {
        const ctrls = ['name', 'price'];
        // NOTE: Add priceGross
        let disabled = false;

        if (this.item.disabled) {
          return true;
        }

        for (let i = 0, len = ctrls.length; i < len; i++) {
          disabled =
            disabled ||
            !this.item.controls[ctrls[i]].value ||
            this.item.controls[ctrls[i]].invalid;
        }

        if (disabled) {
          return true;
        }

        // If loading item

        // Duplicating from another document that populates item with some
        // custom values that shouldn't be saved as item.
        // Only present on outgoing docs
        disabled =
          disabled ||
          (this.item.controls.documentId &&
            this.item.controls.documentId.value);

        return disabled;
      }),
      takeUntil(this.onDestroy$),
    );

    // ((itemGroup.controls.priceGross.value
    //   ? itemGroup.controls.priceGross.pristine
    //   : itemGroup.get('price').pristine) &&
    //   itemGroup.get('name').pristine &&
    //   itemGroup.get('unit').pristine &&
    //   itemGroup.get('_documentItemTaxes').pristine) ||
    // loading.item
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  onSave(): void {
    this.loading.save = true;

    const item = this.item.value;

    if (item.itemId) {
      item.id = item.itemId;
    }

    this.orgService.active
      .pipe(
        switchMap((org: Organization) =>
          item.id
            ? this.itemService.update(item.id, item)
            : this.itemService.create(org.id, item),
        ),
        take(1),
      )
      .subscribe((data: Item) => {
        this.item.controls.itemId.setValue(data.id, { emitEvent: false });
        this.item.markAsPristine({ onlySelf: true });
        this.saved.emit(data);
      })
      .add(() => (this.loading.item = false));
  }
}
